import React from 'react';
export function VideoSection() {
  return <div className="mb-20" data-id="element-1226">
      <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-wide mb-8 text-center" data-id="element-1227">
        VIDEO
      </h3>
      <div className="max-w-4xl mx-auto aspect-video rounded-xl overflow-hidden shadow-xl" data-id="element-1228">
        <iframe src="https://www.youtube.com/embed/XbV8ILPho98" title="Breton Genesi Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-1229"></iframe>
      </div>
    </div>;
}